import { createRootContextHook } from 'common/util/react';
export const useTours = createRootContextHook("tours");